// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"23":"registro","37":"olvide-password","268":"Home","443":"about","535":"login","926":"renueva-password"}[chunkId] + "." + {"23":"8c7aa049","37":"8c7aa049","268":"a9f7ca62","443":"ce59db19","535":"8c7aa049","926":"8c7aa049"}[chunkId] + ".css";
};